// Maps the current URL's portal prefix to that portal's login route, so that a
// 401 / expired-session / failed-login redirect keeps the user in the module
// they're already in (e.g. a driving-school user goes to /driving-school/login,
// not the learner login). Portals without a dedicated login screen fall back to
// the learner login.
const PORTAL_LOGIN_ROUTES: Record<string, string> = {
  learner: '/learner/login',
  'driving-school': '/driving-school/login',
  instructor: '/driving-school/login',
  'vis-instructor': '/driving-school/login',
  'driving-institute': '/vis/login',
  vis: '/vis/login',
  'vis-examiner': '/vis/login',
};

const FALLBACK_LOGIN_ROUTE = '/learner/login';

export function resolveLoginRoute(url: string | null | undefined): string {
  if (!url) return FALLBACK_LOGIN_ROUTE;
  // First path segment, ignoring query string / fragment: e.g.
  // "/driving-school/portal/dashboard" -> "driving-school".
  const [firstSegment] = url.split(/[?#]/)[0].split('/').filter(Boolean);
  return PORTAL_LOGIN_ROUTES[firstSegment] ?? FALLBACK_LOGIN_ROUTE;
}
